<template>
  <div v-loading="isLoading">
    <div v-show="showObj.openDone">
      <div style="margin-bottom:20px">
        <span style="font-weight:bold;font-size:14px">养老服务信息</span>
      </div>
      <div>
        <el-form size="medium" labelWidth="130px" labelPosition="right">
          <el-form-item label="所属社区">
            <span>{{baseOpenObj.community}}</span>
          </el-form-item>
          <el-form-item label="老人分类">
            <span>{{baseOpenObj.type}}</span>
            <span style="margin-left:20px" v-if="isCenterOrCommunity">
              <el-popover placement="right" width="400" trigger="click">
                <el-form size="mini" labelWidth="120px" labelPosition="right">
                  <el-form-item label="老人分类">
                    <el-select v-model="resetTypeValue">
                      <el-option
                        v-for="(item,index) in olderTypeList"
                        :key="index"
                        :value="item.value"
                        :label="item.label"
                        :disabled="item.disabled"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <!-- <el-form-item label="享受补贴者">
                    <el-select v-model="sameAccountMain">
                      <el-option
                        v-for="(item,index) in olderTypeList"
                        :key="index"
                        :value="item.value"
                        :label="item.label"
                      ></el-option>
                    </el-select>
                  </el-form-item>-->
                  <el-form-item label>
                    <el-button type="primary" @click="updateAgedInfo">提交</el-button>
                  </el-form-item>
                </el-form>
                <el-button
                  slot="reference"
                  size="mini"
                  type="primary"
                  :disabled="notOnLine"
                  @click="resetType"
                >重新认定</el-button>
              </el-popover>
            </span>
            <p style="font-size:14px;color:#409EFF">{{agedFont}}</p>
          </el-form-item>
          <!-- <el-form-item label="同户服务对象">
            <span>{{baseOpenObj.sameAccountName}}</span>
          </el-form-item>-->
          <el-form-item label="开通时间">
            <span>{{baseOpenObj.openTime}}</span>
          </el-form-item>
        </el-form>
      </div>
      <el-divider></el-divider>
      <div v-if="isCenter">
        <el-button
          type="primary"
          :disabled="notOnLine"
          style="margin-left:120px"
          @click="purseSubsidy"
        >暂停补贴发放</el-button>
      </div>
    </div>
    <div v-show="showObj.openPending">
      <h1>该服务对象养老服务正在审批中,请耐心等待</h1>
    </div>
    <div v-show="showObj.firstOpen" class="openBtn">
      <div>
        <img src="@/assets/images/ylserve.png" alt />
      </div>
      <div>
        <el-button type="primary" :disabled="notOnLine" @click="openServe">启动养老服务审批</el-button>
      </div>
    </div>
    <div v-show="showObj.firstOpenHandle">
      <el-form
        size="mini"
        :model="openObj.form"
        :rules="openObj.openRules"
        ref="addApprove"
        labelWidth="130px"
        labelPosition="right"
      >
        <el-form-item label="基础信息">
          <div v-if="baseOpenObj.isBaseInfoPerfect">
            <span style="color:green;cursor:pointer" @click="lookBase">已完善</span>
          </div>
          <div v-else>
            <span style="color:orange;cursor:pointer" @click="lookBase">暂未完善</span>
          </div>
        </el-form-item>
        <el-form-item label="特征采集">
          <div v-if="baseOpenObj.hasFaceInfo">
            <span style="color:green;cursor:pointer" @click="lookBase">已完善</span>
          </div>
          <div v-else>
            <span style="color:orange;cursor:pointer" @click="lookBase">暂未采集</span>
          </div>
        </el-form-item>
        <el-form-item label="老人分类" prop="theOldToBeType">
          <el-select v-model="openObj.form.theOldToBeType" :disabled="handleDisabled">
            <el-option value="A" label="A类老人"></el-option>
            <el-option value="B" label="B类老人"></el-option>
            <el-option value="C" label="C类老人"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label>
          <el-button size="mini" type="primary" @click="submit" :disabled="handleDisabled">提交申请</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-divider v-if="showRecord"></el-divider>
    <el-card v-if="showRecord">
      <div slot="header">
        <span>养老服务审批记录</span>
      </div>
      <el-collapse v-model="activeName" accordion>
        <el-collapse-item
          :title="item.title"
          :name="item.title"
          v-for="(item,index) in recordList"
          :key="index"
        >
          <el-form size="mini" labelPosition="right" labelWidth="150px">
            <el-form-item label="提交时间">
              <span>{{item.createTime}}</span>
            </el-form-item>
            <el-form-item label="老人类型">{{item.theOldType|olderType}}</el-form-item>
            <el-form-item label="目标类型">{{item.theOldToBeType|olderType}}</el-form-item>
            <el-form-item label="处理时间">{{item.handleTime|nullFilter}}</el-form-item>
            <el-form-item label="处理人">{{item.operatorName|nullFilter}}</el-form-item>
            <el-form-item label="审批状态">{{item.status|approvalStatus}}</el-form-item>
            <el-form-item label="审批备注">{{item.description|nullFilter}}</el-form-item>
          </el-form>
        </el-collapse-item>
      </el-collapse>
    </el-card>
  </div>
</template>
<script>
import {
  addServiceApprove,
  purseOlderAged,
  updateAgedInfo,
  getApproveList
} from "@/services/all-api.js";
import dataApi from "../../_api/api";
import { mapState } from "vuex"
export default {
  inject: ["reload"],
  data() {
    return {
      showRecord: false,
      recordList: [],
      activeName: '审批记录 1',
      handleDisabled: false,
      agedFont: [
        ""
      ],
      resetTypeValue: "",
      sameAccountMain: "",
      olderTypeList: [],
      isCenterOrCommunity: this.$store.state.userRole === "128" ? true : this.$store.state.userRole === "64" ? true : false,
      isCenter: this.$store.state.userRole === "128" ? true : false,
      isLoading: false,
      showObj: {
        openDone: false,
        openPending: false,
        firstOpen: false,
        firstOpenHandle: false
      },
      //老人基础信息
      baseOpenObj: {
        nurseWay: "",
        community: "",
        type: "",
        sameAccountName: "",
        openTime: "",
        hasFaceInfo: "",
        hasSameHouseHold: "",
        isBaseInfoPerfect: "",
        isOpenAgedService: ""
      },
      //同户对象 信息
      sameAccountObj: {
        gid: "",
        name: ""
      },
      openObj: {
        form: {
          theOldToBeType: ""
        },
        openRules: {
          theOldToBeType: [
            { required: true, message: "请选择老人类型", trigger: "blur" }
          ]
        }
      }
    };
  },
  computed: {
    ...mapState(['oneOlder', 'userRole']),
    notOnLine() {
      return this.oneOlder.status !== 0
    }
  },
  methods: {
    getApproveRecord() {
      const reqObj = {
        index: 0, size: 100, theOldGid: this.oneOlder.theOldGid
      }
      getApproveList(reqObj).then(
        res => {
          let data = res.data.data;
          if (data.length > 0) {
            this.showRecord = true;
          }
          this.recordList = data.map((item, index) => ({
            ...item,
            title: `审批记录 ${index + 1}`
          }))
        }
      )
    },
    lookBase() {
      var that = this;
      this.$router.push({
        path: "/olders/oldermanage/olderdetailindex/baseinfo",
        query: { aim: "face" }
      });
    },
    firstGetAll() {
      this.isLoading = true;
      const detailReq = {
        gid: this.oneOlder.theOldGid
      };
      const openReq = {
        index: 0,
        size: 100000,
        status: 0,
        type: 1,
        theoldgid: this.oneOlder.theOldGid
      };
      dataApi
        .openService(detailReq, openReq)
        .then(res => {
          if (
            res.serviceForm.hasFaceInfo &&
            res.serviceForm.isBaseInfoPerfect
          ) {
            this.handleDisabled = false;
          } else {
            this.handleDisabled = true;
          }
          this.baseOpenObj = res.serviceForm;
          //不能重新认定已有类型的老人
          this.olderTypeList = this.$xiaLaList.getOlderType().map((item, index) => {
            if (res.serviceForm.type === item.label) {
              return ({ value: item.value, label: item.label, disabled: true })
            }
            else {
              return item
            }
          })
          this.sameAccountObj = res.sameAccount.data;
          if (res.openning === true) {
            this.showObj.openPending = true;
          } else if (res.serviceForm.isOpenAgedService) {
            this.showObj.openDone = true
          } else {
            this.showObj.firstOpen = true
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    openServe() {
      if (this.oneOlder.status === 1) {
        this.$message.error("该老人账号已锁定!")
        return false
      }
      if (this.oneOlder.status === 2) {
        this.$message.error("该老人账号已注销!")
        return false
      }
      this.showObj.firstOpenHandle = true;
      this.showObj.firstOpen = false;
    },
    submit() {
      this.$refs.addApprove.validate(valid => {
        if (valid) {
          const reqObj = {
            theoldgid: this.oneOlder.theOldGid,
            type: 1,
            theOldtobetype: this.openObj.form.theOldToBeType
          };
          addServiceApprove(reqObj).then(res => {
            if (res.code === 0) {
              this.$message({
                type: "success",
                message: "审批提交成功!"
              });
              this.reload();
            } else {
              this.$message({
                type: "error",
                message: `审批提交失败:${res.des}`
              });
            }
          });
        }
      });
    },
    updateAgedInfo() {
      if (!this.resetTypeValue) {
        this.$message({
          type: "error",
          message: "请选择老人类型"
        })
        return false
      }
      if (this.$store.state.userRole === "128") {
        const reqObj = {
          type: 1,
          theoldgid: this.oneOlder.theOldGid,
          type: parseInt(this.resetTypeValue)
        };
        updateAgedInfo(reqObj).then(res => {
          if (res.code == 0) {
            this.$message({
              type: "success",
              message: "老人养老服务信息更改成功"
            });
            this.reload();
          } else {
            this.$message({
              type: "error",
              message: `养老服务信息更改失败:${res.des}`
            });
          }
        });
      }
      else if (this.$store.state.userRole === "64") {
        const reqObj = {
          theoldgid: this.oneOlder.theOldGid,
          type: 1,
          theOldtobetype: parseInt(this.resetTypeValue)
        }
        addServiceApprove(reqObj).then(res => {
          if (res.code === 0) {
            this.$message({
              type: "success",
              message: "审批提交成功!"
            });
            this.reload();
          } else {
            this.$message({
              type: "error",
              message: `审批提交失败:${res.des}`
            });
          }
        });
      }
    },
    purseSubsidy() {
      this.$confirm("确定暂停该老人的养老服务?", "提示", {
        confirmButtonText: "确定",
        cancleButtonText: "取消",
        type: "error"
      })
        .then(() => {
          const reqObj = {
            theoldgid: this.oneOlder.theOldGid,
            isOpen: false
          };
          purseOlderAged(reqObj).then(res => {
            if (res.code == 0) {
              this.$message({
                type: "success",
                message: `${res.des}`
              });
              this.reload();
            } else {
              this.$message({
                type: "error",
                message: `开通失败:${res.des}`
              });
            }
          });
        })
        .catch(() => { });
    },
    resetType() {
    }
  },
  mounted() {
    this.getApproveRecord();
    this.firstGetAll();
  }
};
</script>
<style lang="scss" scoped>
.openBtn {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-flow: column;
}
</style>
